import { useMemo } from 'react';
import {
  useModelAndAttributeFromPath,
  useGlobalComponentForAttribute,
  TableInheritedProps
} from '@rhino-project/core/hooks';
import { RhinoResourceSpecifier } from '@rhino-project/core';
import { CellBadge } from '../../table/cells/CellBadge';

// Slots defined in styles.css; a sixth enum value wraps back to the first.
const CATEGORICAL_SLOTS = 5;

const humanizeEnum = (value: string | undefined) =>
  value?.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()) ?? '';

export const ModelCellEnumBase = (props: TableInheritedProps) => {
  const { getValue, model, path } = props;
  const { attribute } = useModelAndAttributeFromPath(
    model as RhinoResourceSpecifier,
    path as string
  );

  const style = useMemo(() => {
    if (!getValue!()) return {};

    const idx = attribute?.enum?.findIndex((e) => e === getValue!());
    const slot = ((idx ?? -1) >= 0 ? idx! : 0) % CATEGORICAL_SLOTS;

    return {
      backgroundColor: `var(--rhino-categorical-${slot + 1}-surface)`,
      color: `var(--rhino-categorical-${slot + 1}-ink)`
    };
  }, [attribute, getValue]);

  const humanizedGetValue = useMemo(
    () => () =>
      attribute?.enumLabels?.[String(getValue!())] || humanizeEnum(getValue!()),
    [attribute?.enumLabels, getValue]
  );

  return (
    <CellBadge
      style={style}
      color="none"
      {...props}
      getValue={humanizedGetValue}
    />
  );
};

export const ModelCellEnum = (props: TableInheritedProps) =>
  useGlobalComponentForAttribute('ModelCellEnum', ModelCellEnumBase, props);
